import { createAction } from 'redux-actions';

const prefix = 'autosave';

export const INIT            = `${prefix}/Init`;
export const REFRESH_STARTED = `${prefix}/RefreshStarted`;
export const REFRESHED       = `${prefix}/Refreshed`;
export const SAVE_STARTED    = `${prefix}/SaveStarted`;
export const SAVED           = `${prefix}/Saved`;
export const DISCONNECTED    = `${prefix}/Disconnected`;
export const ERROR           = `${prefix}/Error`;

export const init           = createAction(INIT);
export const refreshStarted = createAction(REFRESH_STARTED);
export const refreshed      = createAction(REFRESHED);
export const saveStarted    = createAction(SAVE_STARTED);
export const saved          = createAction(SAVED);
export const disconnected   = createAction(DISCONNECTED);
export const error          = createAction(ERROR);
